import { type ThemeOptions } from '@mui/material';
import { orange, red } from '@mui/material/colors';
// import { fuseDark, skyBlue } from '@fuse/colors';

type FuseTheme = {
	logo?: string;
} & ThemeOptions;

// const lightText = {
// 	primary: 'rgb(17, 24, 39)',
// 	secondary: 'rgb(107, 114, 128)',
// 	disabled: 'rgb(149, 156, 169)'
// };

// const darkText = {
// 	primary: 'rgb(255,255,255)',
// 	secondary: 'rgb(229, 231, 235)',
// 	disabled: 'rgb(156, 163, 175)'
// };

const lightText = {
	primary: '#233238',
	secondary: '#546E7A',
	disabled: 'rgba(0, 0, 0, 0.2)'
};

const darkText = {
	primary: 'rgb(255,255,255)',
	secondary: 'rgb(229, 231, 235)',
	disabled: 'rgb(156, 163, 175)'
};

const themesConfig: { [id: string]: FuseTheme } = {
	PerceptiveStyle: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#333333'
			},
			secondary: {
				main: '#ef7829'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		}
	},
	WiseStyle: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#036274',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#069992',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		},
		logo: 'assets/images/logo/wise-logo.svg'
	},
	WiseStyleDark: {
		palette: {
			mode: 'dark',
			text: {
				disabled: 'rgba(0, 0, 0, 0.2)'
			},
			primary: {
				main: '#006174',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#009a92',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#282C34',
				default: '#1C2025'
			},
			error: red,
			warning: orange
		}
	},
	PoloStyle: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#181818',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#006BA4',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		},
		logo: 'assets/images/logo/polo-logo.svg'
	},
	HeadvisorStyle: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#428BAD',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#004D6E',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		},
		logo: 'assets/images/logo/headvisor-logo.svg'
	},
	CreditTheme: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#192D3E',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#6D73A2',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		},
		logo: 'assets/images/logo/creditteam-logo.svg'
	},
	InTheme: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#054A29',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#008940',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		}
		// logo: 'assets/images/logo/intraining-logo.svg'
	},
	PFTheme: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#969696',
				contrastText: '#252525'
			},
			secondary: {
				main: '#252525',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		},
		logo: 'assets/images/logo/pf-logo.svg'
	},
	Light: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#3949AB',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#5850EC',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F4F6F8'
			},
			error: red,
			warning: orange
		}
	},
	Sunset: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#FF908B',
				main: '#D0605E',
				dark: '#9B3134',
				contrastText: '#FFFFFF'
			},
			secondary: {
				light: '#C76A1D',
				main: '#FF994C',
				dark: '#FFCA7B',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F4F6F8'
			},
			error: red,
			warning: orange
		}
	},
	Candy: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#86FFF7',
				main: '#4ECDC4',
				dark: '#009B94',
				contrastText: '#FFFFFF'
			},
			secondary: {
				light: '#FF9D99',
				main: '#FF6B6B',
				dark: '#C73840',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F4F6F8'
			},
			error: red,
			warning: orange
		}
	},
	Urban: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#C4D8DD',
				main: '#93A7AB',
				dark: '#65787C',
				contrastText: '#FFF'
			},
			secondary: {
				light: '#FFB281',
				main: '#F18153',
				dark: '#BA5228',
				contrastText: '#FFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F4F6F8'
			},
			error: red,
			warning: orange
		}
	},
	Canary: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#fdf3da',
				main: '#f8d683',
				dark: '#f3bc53',
				contrastText: '#252525'
			},
			secondary: {
				light: '#FADCB3',
				main: '#F3B25F',
				dark: '#ec9339',
				contrastText: '#252525'
			},
			background: {
				paper: '#FAFBFD',
				default: '#FFFFFF'
			},
			error: red,
			warning: orange
		}
	},
	Shell: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#D2EFF2',
				main: '#68C8D5',
				dark: '#3AA7BA'
			},
			secondary: {
				light: '#FFF2C6',
				main: '#FED441',
				dark: '#FDB91C',
				contrastText: '#1E1F23'
			},
			background: {
				paper: '#FAF6F3',
				default: '#FFFFFF'
			},
			error: red,
			warning: orange
		}
	},
	Notepad: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#D3C0CD',
				main: '#6B2C57',
				dark: '#3C102C'
			},
			secondary: {
				light: '#FDEAC9',
				main: '#F9B84B',
				dark: '#F59123',
				contrastText: '#1E1F23'
			},
			background: {
				paper: '#FFFFFF',
				default: '#FAFAFE'
			},
			error: red,
			warning: orange
		}
	},
	Bee: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#C6C9CD',
				main: '#404B57',
				dark: '#1C232C'
			},
			secondary: {
				light: '#FEEDC7',
				main: '#FCC344',
				dark: '#FAA11F',
				contrastText: '#1E1F23'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F5F4F6'
			},
			error: red,
			warning: orange
		}
	},
	Monochrome: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				light: '#C4C4C4',
				main: '#3A3A3A',
				dark: '#181818'
			},
			secondary: {
				light: '#EFEFED',
				main: '#CBCAC3',
				dark: '#ACABA1',
				contrastText: '#1E1F23'
			},
			background: {
				paper: '#EFEEE7',
				default: '#FAF8F2'
			},
			error: red,
			warning: orange
		}
	},
	'Pink Lavander': {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#735D78',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#B392AC',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		}
	},
	Dark: {
		palette: {
			mode: 'dark',
			text: darkText,
			primary: {
				main: '#8A85FF',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#8A85FF',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#282C34',
				default: '#1C2025'
			},
			error: red,
			warning: orange
		}
	},
	SecretBFG: {
		palette: {
			mode: 'dark',
			text: darkText,
			primary: {
				main: '#3D5AFE',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#E91E63',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#282C34',
				default: '#1C2025'
			},
			error: red,
			warning: orange
		}
	},
	DarkRed: {
		palette: {
			mode: 'dark',
			text: darkText,
			primary: {
				light: '#FFC7CE',
				main: '#FF445D',
				dark: '#FF1F30'
			},
			secondary: {
				light: '#B4E3FB',
				main: '#05A2F3',
				dark: '#0175EA',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#2F3438',
				default: '#25292E'
			},
			error: red,
			warning: orange
		}
	},
	DarkYellow: {
		palette: {
			mode: 'dark',
			text: darkText,
			primary: {
				light: '#FFECC5',
				main: '#FEBE3E',
				dark: '#FD991B'
			},
			secondary: {
				light: '#FFC8C7',
				main: '#FE4644',
				dark: '#FD201F',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#2A2E32',
				default: '#212529'
			},
			error: red,
			warning: orange
		}
	},
	DarkGray: {
		palette: {
			mode: 'dark',
			text: darkText,
			primary: {
				light: '#C9CACE',
				main: '#4B4F5A',
				dark: '#23262E'
			},
			secondary: {
				light: '#F8F5F2',
				main: '#E6DED5',
				dark: '#D5C8BA',
				contrastText: '#23262E'
			},
			background: {
				paper: '#31343E',
				default: '#2A2D35'
			},
			error: red,
			warning: orange
		}
	},
	DarkBlue: {
		palette: {
			mode: 'dark',
			text: darkText,
			primary: {
				light: '#C2C8D2',
				main: '#354968',
				dark: '#16213A'
			},
			secondary: {
				light: '#F4CFCA',
				main: '#D55847',
				dark: '#C03325',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#23354E',
				default: '#1B2A3F'
			},
			error: red,
			warning: orange
		}
	},
	DeepOcean: {
		palette: {
			mode: 'dark',
			text: darkText,
			primary: {
				light: '#BEBFC8',
				main: '#252949',
				dark: '#0D0F21'
			},
			secondary: {
				light: '#CBD7FE',
				main: '#5079FC',
				dark: '#2749FA',
				contrastText: '#1A1E22'
			},
			background: {
				paper: '#2D3159',
				default: '#202441'
			},
			error: red,
			warning: orange
		}
	}
};

const companiesThemesConfig: { [id: string]: FuseTheme } = {
	InTheme: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#054A29',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#008940',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		}
		// logo: 'assets/images/logo/intraining-logo.svg'
	},
	HeadvisorStyle: {
		palette: {
			mode: 'light',
			text: lightText,
			common: {
				black: 'rgb(17, 24, 39)',
				white: 'rgb(255, 255, 255)'
			},
			primary: {
				main: '#428BAD',
				contrastText: '#FFFFFF'
			},
			secondary: {
				main: '#004D6E',
				contrastText: '#FFFFFF'
			},
			background: {
				paper: '#FFFFFF',
				default: '#F6F7F9'
			},
			error: red,
			warning: orange
		},
		logo: 'assets/images/logo/headvisor-logo.svg'
	}
};

if (import.meta.env.VITE_DEFAULT_THEME) {
	const companyTheme = companiesThemesConfig[import.meta.env.VITE_DEFAULT_THEME];
	if (companyTheme) themesConfig[import.meta.env.VITE_DEFAULT_THEME] = companyTheme;
}

export default themesConfig;
